import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconHighlighter = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72.0032717,
			d: "m234.595 786.873-67.507-67.507 73.824-73.825-29.767-117.132S634.949 183.137 748.973 90.25c15.862-12.936 38.965-11.757 53.447 2.725l126.073 126.073c14.482 14.482 15.652 37.576 2.725 53.447-92.887 114.024-438.159 537.828-438.159 537.828l-117.132-29.767-73.825 73.824zM580.177 703.385l-262.46-262.46"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 51.81,
			d: "M5732.15 5306.9v-129.48l-59.65 51.37v78.11",
			transform: "rotate(-135 3078.715 5523.328)scale(1.47993 1.29293)"
		})
	]
});
export default SvgIconHighlighter;
